import React, { useState } from 'react';
import { Repeat, CheckCircle2, XCircle, BarChart3 } from 'lucide-react';

const RegressionAutomation = ({ project }) => {
  const [results] = useState({
    total_tests: 156,
    passed: 142,
    failed: 14,
    test_results: [
      { transaction: 'VA01', ecc_behavior: 'Order created', s4_behavior: 'Order created', match: true },
      { transaction: 'VL01N', ecc_behavior: 'Delivery posted', s4_behavior: 'Delivery posted', match: true },
      { transaction: 'MIRO', ecc_behavior: 'Invoice verified', s4_behavior: 'Different posting date logic', match: false },
      { transaction: 'FB01', ecc_behavior: 'Journal entry posted', s4_behavior: 'Universal Journal posted', match: true }
    ]
  });

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h2 className="text-3xl font-bold mb-2">Regression Automation Engine</h2>
        <p className="text-gray-600">Compare ECC vs S/4HANA behavior automatically</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-blue-500 rounded-xl p-6 text-white">
          <BarChart3 className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{results.total_tests}</div>
          <div className="text-sm">Total Tests</div>
        </div>
        <div className="bg-green-500 rounded-xl p-6 text-white">
          <CheckCircle2 className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{results.passed}</div>
          <div className="text-sm">Passed</div>
        </div>
        <div className="bg-red-500 rounded-xl p-6 text-white">
          <XCircle className="w-10 h-10 mb-3 opacity-80" />
          <div className="text-3xl font-bold mb-2">{results.failed}</div>
          <div className="text-sm">Failed</div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4">Regression Test Results</h3>
        <div className="space-y-3">
          {results.test_results.map((test, i) => (
            <div key={i} className={`border-2 rounded-lg p-4 ${
              test.match ? 'border-green-200 bg-green-50' : 'border-red-200 bg-red-50'
            }`}>
              <div className="flex items-start space-x-3">
                {test.match ? <CheckCircle2 className="w-5 h-5 text-green-600 mt-0.5" /> : <XCircle className="w-5 h-5 text-red-600 mt-0.5" />}
                <div className="flex-1">
                  <h4 className="font-semibold mb-2">{test.transaction}</h4>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <p className="text-gray-500">ECC Behavior</p>
                      <p className="font-semibold">{test.ecc_behavior}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">S/4 Behavior</p>
                      <p className="font-semibold">{test.s4_behavior}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RegressionAutomation;